import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAppConfigByConfgType = async (configType?: string) => {
    const response = http.get(`/appconfig/${configType !== undefined ? configType : ''}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllAppConfig = async () => {
    const response = http.get(`/appconfig/appconfigurations`)
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updateAppConfig = async (ConfigType : string, data: any) => {
    const response = http.put(`/appconfig/update?ConfigType=${ConfigType}`, data)
    return response;
}
